module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ACc"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "JANUARY 14: The Lifter of Your Head"
    }
  }, [_c('h1', {
    staticClass: "chapter2",
    attrs: {
      "id": "pAo4W"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#AB_ch15",
      "id": "AB_cha15"
    }
  }, [_vm._v("JANUARY 14"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "chapter2a"
  }, [_vm._v("The Lifter of Your Head")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "ext",
    attrs: {
      "id": "pA1NL"
    }
  }, [_c('em', [_vm._v("You, O L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(", are a shield for me, my glory and the One who lifts up my head.")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pAZo7"
    }
  }, [_vm._v("—Psalm 3:3")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "AEuN"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_vm._v("Y")])]), _vm._v("ou’ve probably heard the expression “Keep your chin up!” Someone in your life may have spoken these words to you in a time of trouble or discouragement. One of the earliest uses of this phrase appears to have been in the Warren, Pennsylvania, newspaper called the "), _c('em', [_vm._v("Evening Democrat")]), _vm._v(". In October 1900, the following wisdom was offered under the title “Epigrams Upon the Health-giving Qualities of Mirth”: “Keep your chin up. Don’t take your troubles to bed with you. Hang them on a chair with your trousers or drop them in a glass of water with your teeth.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAXQN"
    }
  }, [_vm._v("As simple as this advice sounds, being optimistic in a difficult situation is a tough assignment. Just ask King David, who wrote Psalm 3. For him the idea of keeping his chin up was heartbreakingly difficult. At the time he wrote these words, he was fleeing from his son Absalom, who desperately wanted David dead so he could sit on the throne. “Keep your chin up” would have sounded trite to David, although it was true that looking up to God was the best course of action. And God helped lift David’s head above his fears and doubts.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAtDs"
    }
  }, [_vm._v("Remember that you can keep your chin up. Our gracious God is “the One who lifts up [our heads].”")]), _vm._v(" "), _c('p', {
    staticClass: "left1",
    attrs: {
      "id": "pA4v"
    }
  }, [_c('em', [_vm._v("I am grateful, Lord God, that You are indeed the lifter of my head when I need hope.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b59b5c6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter15.vue
// module id = 111
// module chunks = 0